import {Howl, Howler} from 'howler';
import {TweenLite, TimelineMax, Linear} from "gsap";

let tracks: Howl[] = [];
let keys = [
    "vXCYmJENK4rtk2",
    "Yb8RifEVhisBA7",
    "GB2RNthC3iBeWv",
    "6rdzN8iZBJdyXj",
    "DzTFWfZ2NWQF6V",
    "YPt8ptK2tgAjzi",
    "oFm3tYHo2gMczs",
    "2qnrd6mTXPqCWz"
]

let backgroundImages = [
    "#bg-into-the-abyss",
    "#bg-possession",
    "#bg-the-myst-divides-us",
];

export function setup() {
    document.querySelectorAll(".track-link").forEach(o => o.addEventListener("click", playClick));
    
    tracks.push(new Howl({src: ['audio/1.mp3']}));
    tracks.push(new Howl({src: ['audio/2.mp3']}));
    tracks.push(new Howl({src: ['audio/3.mp3']}));

    document.querySelector("#scrub").addEventListener("mousedown", scrub);
    document.querySelector("#scrub").addEventListener("mousemove", scrub);
    document.querySelector("#play-button #submit").addEventListener("click", firstPlay);
    document.querySelector("form#key-form").addEventListener("submit", firstPlay);

    // Put the key from the url in the box
    let urlParts = window.location.href.match(/\?\w+/);
    if (urlParts.length >= 1) document.querySelector("#access-key").value = urlParts[0].substr(1);
}

function playClick(e) {
    e.preventDefault();
    let trackNum = parseInt(e.target.id.substr(-1))-1;
    play(trackNum);
}

let speedTween = new TimelineMax();

function play(trackNum) {
    speedTween.kill();
    speedTween.to(window["rotateSpeedMultiplier"], 0.1, {x: 10}).to(window["rotateSpeedMultiplier"], 0.7, {x: 1});

    document.querySelectorAll("#player a").forEach(o => o.classList.remove("selected"));
    document.querySelectorAll("#player a")[trackNum].classList.add("selected");

    let currentTrackName = document.querySelectorAll("#player a")[trackNum];
    tweenTrackName(currentTrackName);

    let allBgs = (document.querySelectorAll(".bg"));
    let bgEl = (document.querySelector(backgroundImages[trackNum]) as HTMLElement);
    TweenLite.to(allBgs, 0.2, {"opacity": 0, onComplete: () => {
        TweenLite.to(bgEl, 0.3, {"opacity": 1});
    }});
    
    if (tracks[trackNum].playing()) tracks[trackNum].seek(0);
    else {
        pauseAll();
        tracks[trackNum].play();
    }
}

var tl: TimelineMax;

function tweenTrackName(trackNameEl) {
    if (tl) tl.kill();
    // Set up the tween on the playing item
    tl = new TimelineMax({repeat: -1, ease: Linear, });
    tl.to(trackNameEl, 5, {"scaleX": 1.2})
        .to(trackNameEl, 10, {"scaleX": 1})
        .to(trackNameEl, 5, {"scaleX": 0.9});
}

function firstPlay(e) {
    e.preventDefault();

    let key = document.querySelector("#access-key").value;
    if (keys.indexOf(key) < 0) {
        alert("Invalid access key, contact contact@16faces.com for access");
        return
    }

    let currentTrackName = document.querySelectorAll("#player a")[0];
    tweenTrackName(currentTrackName);
    let el = document.querySelector("#play-button");
    TweenLite.to(document.querySelector("#player"), 0.2, {"opacity": 1});
    TweenLite.to(el, 0.2, {"opacity": 0, onComplete: () => {
        document.body.removeChild(el);
        let bgEl = (document.querySelector(backgroundImages[0]) as HTMLElement);
        TweenLite.to(bgEl, 0.3, {"opacity": 1});
        tracks[0].play();
    }});
}

function scrub(e) {
    let pc = e.clientX/window.innerWidth;
}

function pauseAll() {
    tracks.forEach(o => o.pause());
}